module.exports = __webpack_public_path__ + "static/media/details__note.4be1b8e5.svg";